var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form',{ref:"form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"row col-12 pr-0 mb-3"},[_c('span',[_vm._v("Your changes will be lost ! Make sure you save the data before proceeding to the "+_vm._s(_vm.parameters.is_next ? 'next' : 'previous')+" job")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }